// extracted by mini-css-extract-plugin
export var downArrow = "_b4-0";
export var infoTooltipIcon = "_b4-3";
export var label = "_b4-1";
export var optionCard = "_b4-4";
export var upArrow = "_b4-2";